import { TableColumn } from "us.collection.economy/components/CreditorInvoiceDetails/Components/Table/Constants";
import { ColumnFilterTypes } from "us.common/components/antd/TableTree/Constants";

/**
 * @description Get column search input field current value by key
 * @param key - input field name
 * @returns value - Current value of the input field
 */
export const getColumnFilterProps = (key: TableColumn) => {
  switch (key) {
    case TableColumn.VAT_AMOUNT:
    case TableColumn.DISCOUNT:
    case TableColumn.ORDERLINE_TOTAL:
      return { customFilter: ColumnFilterTypes.AMOUNT, showFilters: true };
    default:
      return { customFilter: true, showFilters: true };
  }
};
